module.exports = __webpack_public_path__ + "static/img/09lajifeilei.e3f410df.gif";